import * as util from 'util';
import _ from 'lodash';
import {GeneralService} from '../../../../services/generalService';
import {RouteService} from '../../../../services/routeService';
import {NotificationService} from '../../../../services/notificationService';
import {DICTIONARY} from '../../../../dictionary';
import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {ComposeMessageService} from "../../../../services/composeMessageService";
import html2canvas from "html2canvas";
import {DropdownComponent} from "../../../uiComponents/dropdown/dropdown.component";
import {ENV_CONSTS} from "../../../../constants";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {TrustifiTableComponent} from "../../../uiComponents/trustifi-table/trustifi-table.component";

@Component({
	selector: 'threat-simulation-campaign-wizard',
	templateUrl: './threat-simulation-campaign-wizard.component.html',
})
export class ThreatSimulationCampaignWizardComponent implements OnInit {

	@Input() allCampaignGroups;
	@Input() verifiedDomains;
	@Input() relaunchCampaign: any;
	@Output() cancelCb = new EventEmitter<any>;
	@Output() doneCb = new EventEmitter<any>;
	@ViewChild('templatesDropdownEl') templatesDropdownEl : DropdownComponent;
	@ViewChild('recipientsTableEl') recipientsTableEl : TrustifiTableComponent;

	dic = DICTIONARY;
	step = this.dic.CONSTANTS.threatSimulationNewCampaignSteps.generalInformation;
	userInfo: any;
	templates;
	materials;
	quizMaterials;
	previewTemplateInProcess;
	previewLandingPagePopup;
	previewTemplateData:any = {
		name: '',
		content: null,
		pptUrl: null,
		virtualContent: ''
	};
	loadCampaignDataInProcess;
	createNewCampaignInProcess;
	previewLinkMaterial: SafeResourceUrl;
	isMultipleTemplates;
	allPossibleRecipients;
	showGroups = true;
	showMailboxes = true;
	hours = ['00','01','02','03','04','05','06','07','08','09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
	minutes = ['00', '05','10','15','20','25','30','35','40','45','50','55'];
	_ = _;
	popupError = '';
	now = new Date();
	minScheduleTime = new Date(this.now.getTime() - (this.now.getTimezoneOffset() * 60000)).toISOString().slice(0, 16);
	minScheduleTimeRepeatInterval = new Date(this.now.getTime() - (this.now.getTimezoneOffset() * 60000) + 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 16);
	selectedTemplatePreviewAttachment;
	data = {
		name: '',
		description: '',
		addToGroup: {
			method: 'disabled', // 'disabled', 'existing', 'new'
			groupName: '',
			newGroupName: ''
		},
		repeatInterval: {
			method: 'oneTime', // 'oneTime', 'repeat'
			interval: 1, // in days
			until: this.minScheduleTimeRepeatInterval,
			intervalError: false
		},
		selectedTemplate: null,
		linkedQuiz: null,
		selectedRecipients: [],
		configuration: {
			expired_days: 7,
			apply_default_banners: false,
			notify_on_link_clicked: false,
			notify_on_attachment_clicked: false,
			send_report_when_completed: false,
			send_training_when_completed: false,
			enable_security_awareness_for_mailbox: false,
			security_awareness_for_mailbox_expire_days: 7,
			enable_ack_reminder: false,
			enable_ack_reminder_hours: 1,
			scheduled_time_enabled: false,
			scheduled_time: this.minScheduleTime,
			enable_rate_email_delivery_hours_duration: false,
			rate_email_delivery_hours_duration: 7,
			pilot_campaign: false,
		},
	};

	range = {start: new Date(), end: new Date()};

	recipientsLimitInSummary = 20;
	templatesScreenshots = {};
	launchedSuccessfully;
	createdCampaignId;
	showDynamicFieldsPopup;
	isTrainingCampaign;

	threatSimulationLandingPages;
	filterData;

	constructor(public gs: GeneralService,
				private rs: RouteService,
				private http: HttpClient,
				private router: Router,
				private sanitizer: DomSanitizer,
				private composeMessageService: ComposeMessageService,
				private ns: NotificationService) {
		const currentUrl = this.router.url.split('?')[0].split('#')[0];
		this.isTrainingCampaign = _.last(currentUrl.split('/')) === this.dic.CONSTANTS.threatSimulationCampaignsPageTabs.trainingCampaigns;
	}

	ngOnInit() {
		this.gs.getUserInfo(false, (userInfo) => {
			this.userInfo = userInfo;
		});

		this.initFilters();

		this.getDataForWizard(); // templates, contacts
	};

	// CC: taken from inbound-mailboxes.component.ts -> initFilters
	initFilters = () => {
		this.filterData = {
			filterType: this.dic.CONSTANTS.tableFilters.threatSimulationCampaignRecipients,
			filters: {
				license: [this.dic.CONSTANTS.inboundMailboxTypes.member, this.dic.CONSTANTS.inboundMailboxTypes.guest,
					this.dic.CONSTANTS.inboundMailboxTypes.unlicensed, this.dic.CONSTANTS.inboundMailboxTypes.onpremises,
					this.dic.CONSTANTS.inboundMailboxTypes.disabled]
			},
			initFiltersFunction: this.initFilters,
		};
	};

	getDataForWizard = () => {
		this.loadCampaignDataInProcess = true;
		const promises = [this.getCampaignRecipients()];
		if (this.relaunchCampaign) {
			promises.push(this.getRelaunchCampaignSummary());
		}

		if (!this.isTrainingCampaign) {
			promises.push(this.getTemplates());
		}

		// always get materials. If it's a threat campaign, it will be used for landing pages
		promises.push(this.getMaterials());

		Promise.all(promises)
			.then(results => {
				this.loadCampaignDataInProcess = false;

				if (this.templates?.length) {
					this.formatTemplates();
				}

				this.setLandingPages();

				if (this.relaunchCampaign) {
					this.getDataFromRelaunchedCampaign();
				}
			})
			.catch(error => {
				this.loadCampaignDataInProcess = false;
			});
	}

	formatTemplates = () => {
		this.templates.forEach(templateObj => {
			const trustifiLookupLink = (templateObj.lookup_links || []).find(link => link.link?.startsWith('https://gss.trustifi.com/threatSimulation/'));
			templateObj.hasLandingPageLink = !!trustifiLookupLink;

			// set the name of the landing page for dropdown
			if (trustifiLookupLink && templateObj._id) { // ("_id" exists in custom template only)
				if (trustifiLookupLink.link.includes('landing.html?template=')) {
					templateObj.ts_type = this.dic.CONSTANTS.threatSimulationType.training.display;
					templateObj.landing_page_type = this.dic.CONSTANTS.threatSimulationLandingPageType.training;
				}
				else if (trustifiLookupLink.link.includes('login.html?template=')) {
					templateObj.ts_type = this.dic.CONSTANTS.threatSimulationType.login.display;
					templateObj.landing_page_type = this.dic.CONSTANTS.threatSimulationLandingPageType.login;
				}
				else if (trustifiLookupLink.link.includes('material.html?id=')) {
					const materialId = trustifiLookupLink.link.split("material.html?id=")[1];
					const material = this.materials?.find(material => material._id === materialId);
					if (material) {
						templateObj.ts_type = material.name;
						if (material.ts_type === this.dic.CONSTANTS.threatSimulationType.quiz.value) {
							templateObj.landing_page_type = this.dic.CONSTANTS.threatSimulationLandingPageType.quiz;
						}
						else {
							templateObj.landing_page_type = this.dic.CONSTANTS.threatSimulationLandingPageType.materials;
						}
					}
					else {
						console.error('missing material', materialId, templateObj);
					}
				}
			}
		});
	}

	setLandingPages = () => {
		this.threatSimulationLandingPages = _.compact([
			this.dic.CONSTANTS.threatSimulationType.training,
			this.dic.CONSTANTS.threatSimulationType.login,
			this.materials?.length && {isSeparator: true},
			..._.map(this.materials || [], material => ({...material, display: material.name}))
		]);
		console.log(this.threatSimulationLandingPages)
	}

	getRelaunchCampaignSummary = () => {
		return new Promise(resolve => {
			this.rs.getCampaignSummary(this.relaunchCampaign._id).then((response) => {
				this.relaunchCampaign.recipients = response.recipients;
				resolve(response.recipients);
			}, (err) => {
			});
		});
	}

	getDataFromRelaunchedCampaign = () => {
		this.data.name = this.relaunchCampaign.name;
		this.data.description = this.relaunchCampaign.description;

		// set group
		if (this.relaunchCampaign.group_name) {
			this.data.addToGroup.method = 'existing';
			this.data.addToGroup.groupName = this.relaunchCampaign.group_name;
		}

		// set repeat interval
		if (this.relaunchCampaign.campaign_interval?.days) {
			this.data.repeatInterval.method = 'repeat';
			this.data.repeatInterval.interval = this.relaunchCampaign.campaign_interval.days;
			const date = new Date(this.relaunchCampaign.campaign_interval.expiration);
			this.data.repeatInterval.until = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().slice(0, 16);
		}


		// set template
		if (this.relaunchCampaign.template_name && this.templates) {
			//get template from the list
			const template = this.templates.find(itm => itm.name === this.relaunchCampaign.template_name);
			this.data.selectedTemplate = template;
		}

		// set recipients
		if (this.relaunchCampaign.recipients_count && this.relaunchCampaign.recipients) {
			this.relaunchCampaign.recipients.forEach(recipient => {
				const recipientObj = _.find(this.allPossibleRecipients, {email: recipient.email});
				if (recipientObj) {
					recipientObj.selected = true;
				}
			});
		}

		// set configuration
		this.data.configuration.expired_days = this.relaunchCampaign.configuration.expired_days;
		this.data.configuration.notify_on_link_clicked = this.relaunchCampaign.configuration.notify_on_link_clicked;
		this.data.configuration.apply_default_banners = this.relaunchCampaign.configuration.apply_default_banners;
		this.data.configuration.notify_on_attachment_clicked = this.relaunchCampaign.configuration.notify_on_attachment_clicked;
		this.data.configuration.enable_security_awareness_for_mailbox = this.relaunchCampaign.configuration.enable_security_awareness_for_mailbox;
		this.data.configuration.security_awareness_for_mailbox_expire_days = this.relaunchCampaign.configuration.security_awareness_for_mailbox_expire_days;
		this.data.configuration.enable_ack_reminder = this.relaunchCampaign.configuration.enable_ack_reminder;
		this.data.configuration.enable_ack_reminder_hours = this.relaunchCampaign.configuration.enable_ack_reminder_hours;
		this.data.configuration.send_report_when_completed = this.relaunchCampaign.configuration.send_report_when_completed;
		this.data.configuration.send_training_when_completed = this.relaunchCampaign.configuration.send_training_when_completed;
		this.data.configuration.pilot_campaign = this.relaunchCampaign.configuration.pilot_campaign;

		// set Campaign pace
		if (this.relaunchCampaign.configuration.rate_email_delivery_hours_duration) {
			this.data.configuration.enable_rate_email_delivery_hours_duration = true;
			this.data.configuration.rate_email_delivery_hours_duration = this.relaunchCampaign.configuration.rate_email_delivery_hours_duration;
		}

		// set schedule
		if (this.relaunchCampaign.configuration.scheduled_time_enabled) {
			this.data.configuration.scheduled_time_enabled = true;

			const date = new Date(this.relaunchCampaign.configuration.scheduled_time);
			this.data.configuration.scheduled_time = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().slice(0, 16);
		}
	}

	getTemplates = (): Promise<any> => {
		return new Promise(resolve => {
			this.rs.getThreatSimulationTemplates().then((templates) => {
				this.templates = _.reject(templates, 'upcoming');
				resolve(templates);
			}, (err) => {
			});
		});
	}

	getMaterials = (): Promise<any> => {
		return new Promise(resolve => {
			this.rs.getThreatSimulationMaterials().then((materials) => {
				this.materials = materials;
				this.quizMaterials = materials.filter(m => m.type === 'quiz');
				resolve(materials);
			}, (err) => {
			});
		});
	}

	getCampaignRecipients = (): Promise<any> => {
		return new Promise(resolve => {
			this.rs.getCampaignRecipients().then((recipients) => {
				this.allPossibleRecipients = recipients.groups.concat(recipients.mailboxes);
				resolve(recipients);
			}, (err) => {
			});
		});
	}

	backStep = () => {
		this.popupError = '';

		switch(this.step) {
			case this.dic.CONSTANTS.threatSimulationNewCampaignSteps.selectTemplate:
				this.step = this.dic.CONSTANTS.threatSimulationNewCampaignSteps.generalInformation;
				break;

			case this.dic.CONSTANTS.threatSimulationNewCampaignSteps.selectRecipients:
				this.step = this.dic.CONSTANTS.threatSimulationNewCampaignSteps.selectTemplate;
				break;

			case this.dic.CONSTANTS.threatSimulationNewCampaignSteps.configuration:
				this.step = this.dic.CONSTANTS.threatSimulationNewCampaignSteps.selectRecipients;
				break;

			case this.dic.CONSTANTS.threatSimulationNewCampaignSteps.summary:
				this.step = this.dic.CONSTANTS.threatSimulationNewCampaignSteps.configuration;
				break;
		}
	}

	nextStep = () => {
		this.popupError = '';

		switch (this.step) {
			case this.dic.CONSTANTS.threatSimulationNewCampaignSteps.generalInformation:
				if (!this.data.name) {
					this.popupError = this.dic.ERRORS.fillAllRequired;
					return;
				}

				switch (this.data.addToGroup.method) {
					case "disabled":
						this.data.addToGroup.groupName = '';
						this.data.addToGroup.newGroupName = '';
						break;

					case "existing":
						if (!this.data.addToGroup.groupName) {
							this.popupError = this.dic.ERRORS.fillAllRequired;
							return;
						}
						this.data.addToGroup.newGroupName = '';
						break;

					case "new":
						if (!this.data.addToGroup.newGroupName) {
							this.popupError = this.dic.ERRORS.fillAllRequired;
							return;
						}
						if (_.some(this.allCampaignGroups, {name: this.data.addToGroup.newGroupName})){
							this.popupError = util.format(this.dic.ERRORS.itemAlreadyExist, 'Group with same name');
							return;
						}

						this.data.addToGroup.groupName = '';
						break;
				}

				if (this.data.repeatInterval.method === 'repeat') {
					if (!this.intervalValidation()) {
						this.step = this.dic.CONSTANTS.threatSimulationNewCampaignSteps.selectTemplate;
					}
					else {
						return;
					}
				}
				else {
					this.step = this.dic.CONSTANTS.threatSimulationNewCampaignSteps.selectTemplate;
				}

				if (this.data.selectedTemplate) {
					setTimeout(() => {
						this.selectTemplate(this.data.selectedTemplate, false);
					});
				}
				break;

			case this.dic.CONSTANTS.threatSimulationNewCampaignSteps.selectTemplate:
				if ((!this.isMultipleTemplates && !this.data.selectedTemplate) || (this.isMultipleTemplates && !_.some(this.templates, 'selected'))) {
					this.popupError = util.format(this.dic.ERRORS.noSelected, this.isTrainingCampaign ? 'material' : 'template');
					return;
				}

				this.step = this.dic.CONSTANTS.threatSimulationNewCampaignSteps.selectRecipients;
				break;

			case this.dic.CONSTANTS.threatSimulationNewCampaignSteps.selectRecipients:
				this.data.selectedRecipients = _.filter(this.allPossibleRecipients, 'selected');
				if (!this.data.selectedRecipients.length) {
					this.popupError = util.format(this.dic.ERRORS.selectAtLeastOneX, 'recipient');
					return;
				}

				// validate domains
				const notValidatedDomain = _.find(this.data.selectedRecipients, recipient => !this.verifiedDomains?.includes(this.gs.getEmailDomain(recipient.email)));
				if (notValidatedDomain) {
					this.popupError = util.format(this.dic.ERRORS.domainNotVerifiedForX, notValidatedDomain.email);
					return;
				}

				this.step = this.dic.CONSTANTS.threatSimulationNewCampaignSteps.configuration;
				break;

			case this.dic.CONSTANTS.threatSimulationNewCampaignSteps.configuration:
				if (this.data.configuration.expired_days !== 0 && !this.data.configuration.expired_days) {
					this.popupError = this.dic.ERRORS.fillAllRequired;
					return;
				}
				if (this.data.configuration.expired_days < 1 || this.data.configuration.expired_days > 365) {
					this.popupError = this.dic.ERRORS.expiredInputInvalid;
					return;
				}
				if (this.data.configuration.enable_security_awareness_for_mailbox) {
					if (this.data.configuration.security_awareness_for_mailbox_expire_days < 1 || this.data.configuration.security_awareness_for_mailbox_expire_days > 365) {
						this.popupError = this.dic.ERRORS.expiredInputInvalid;
						return;
					}
				}

				if (this.data.configuration.enable_ack_reminder) {
					if (this.data.configuration.enable_ack_reminder_hours < 1 || this.data.configuration.enable_ack_reminder_hours > 365) {
						this.popupError = this.dic.ERRORS.expiredInputInvalid;
						return;
					}
				}

				this.step = this.dic.CONSTANTS.threatSimulationNewCampaignSteps.summary;
				break;
		}
	}

	drawTemplateScreenshot = (templateName) => {
		if (this.templatesScreenshots[templateName]) {
			document.getElementById('templateScreenshotContainer_' + templateName).appendChild(this.templatesScreenshots[templateName]);
		}
	}

	importItemsFromCSV = (file) => {
		if (!file) return;

		const header = 'email';
		this.gs.readCsv(file, [header], null, null, null, (err, results) => {
			if (err) {
				return;
			}
			if (!results || !results[header] || !results[header].length) {
				this.ns.showWarnMessage(DICTIONARY.ERRORS.noNewResult);
				return;
			}

			for (let i = 0; i < results[header].length; i++) {
				const recipientEmail = results[header][i];
				const recipientObj = _.find(this.allPossibleRecipients, {email: recipientEmail});
				if (recipientObj) {
					recipientObj.selected = true;
				}
			}
		});
	};


	previewLandingPage = (templateObj) => {
		// preview landing page as material
		if (templateObj.landing_page_type === this.dic.CONSTANTS.threatSimulationLandingPageType.materials ||
			templateObj.landing_page_type === this.dic.CONSTANTS.threatSimulationLandingPageType.quiz) {
			const material = _.find(this.materials, {name: templateObj.ts_type});
			this.previewLandingPagePopup = {
				show: true,
				material
			};

			if (material.link_url && material.type !== 'quiz') {
				this.previewLandingPagePopup.linkUrl = this.sanitizer.bypassSecurityTrustResourceUrl(material.link_url);
				return;
			}

			switch (material.type) {
				case 'quiz':
					break;

				case 'application/pdf':
					this.http.get(ENV_CONSTS.attachmentUrl + '/admin/threatSimulation/material/content/' + material._id,{responseType: 'arraybuffer', headers: this.gs.getHeaders(), observe: 'response'})
						.subscribe((response) => {
							if (response && response.body.byteLength === 0) {
								this.ns.showErrorMessage(this.dic.ERRORS.fileDownloadFailed);
								this.previewLandingPagePopup = null;
								return;
							}
							this.previewLandingPagePopup.pdfContent = {
								name: material.name,
								type: material.type,
								content: response
							};
						}, err => {
							console.error(err);
							this.ns.showErrorMessage(this.dic.ERRORS.fileDownloadFailed);
							this.previewLandingPagePopup = null;
						});
					break;

				default: // ppt
					this.rs.getThreatSimulationMaterialContentEnc(material._id).then((enc) => {
						const pptUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${ENV_CONSTS.outsideUrl}/ts/content/${enc}?materialId=${material._id}`;
						this.previewLandingPagePopup.pptUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pptUrl);
					}, err => {
						console.error(err);
						this.ns.showErrorMessage(this.dic.ERRORS.fileDownloadFailed);
						this.previewLandingPagePopup = null;
					});
			}
		}

		// preview normal landing page
		else {
			window.open(templateObj.lookup_links[0].link, '_blank');
		}
	}

	toggleTemplatesDropdown = () => {
		this.popupError = '';

		setTimeout(() => {
			this.templatesDropdownEl.dropdownClicked();
		});
	}

	selectTemplate = (template, isItemSelectCheckboxClicked) => {
		// if user clicked on the checkbox to only select the template (when multiple selection), don't preview the template on screen
		if (isItemSelectCheckboxClicked) {
			this.popupError = '';
			if (template.selected) {
				this.previewTemplate(template, true);
			}

			return;
		}

		template.selected = !template.selected;
		this.data.selectedTemplate = template;
		this.data.linkedQuiz = null;
		this.data.selectedTemplate.availableSubtitlesLanguages = (template.video_subtitles || []).filter(sub => sub.segments).map(sub => this.dic.CONSTANTS.subtitleLanguages[sub.lang] || sub.lang);
		this.previewTemplate(template);
	}

	testTemplate = (templateObj) => {
		this.gs.showPopup({
			title: `Test Template`,
			body: ['<a class="blue-link flex-row gap-1 align-items-center fw-bold" href="https://docs.trustifi.com/docs/enabling-the-threat-simulation-service" target="_blank">' +
			'<span style="font-size: 12px;">Review the full guide</span>' +
			'<i class="far fa-external-link-alt" style="font-size: 10px;"></i>' +
			'</a>'],
			subTitle: 'A test email of this campaign will be sent to your mailbox to verify deliverability. If the email was not delivered, please check your configuration',
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Test',
			doneCb: () => {
				let tsType;
				if (this.isTrainingCampaign) {
					tsType = templateObj.type === 'quiz' ? this.dic.CONSTANTS.threatSimulationType.quiz.value : this.dic.CONSTANTS.threatSimulationType.materials.value;
				}
				else if (templateObj.landing_page_type === this.dic.CONSTANTS.threatSimulationLandingPageType.materials ||
					templateObj.landing_page_type === this.dic.CONSTANTS.threatSimulationLandingPageType.quiz) {
					tsType = this.dic.CONSTANTS.threatSimulationType.training.value;
				}
				else {
					tsType = this.getTsTypeValue(templateObj.ts_type);
				}

				const campaignTestObj:any = {
					name: 'test',
					description: 'test',
					rcptTo: [{email: this.userInfo.email}],
					emailData: {name: templateObj.name, landing_page_type: templateObj.landing_page_type, ts_type: tsType}
				};
				if (this.isTrainingCampaign) {
					campaignTestObj.emailData.material_id = templateObj._id;
					campaignTestObj.emailData.landing_page_type = this.dic.CONSTANTS.threatSimulationLandingPageType.materials;
				}
				if (templateObj.landing_page_type === this.dic.CONSTANTS.threatSimulationLandingPageType.materials ||
					templateObj.landing_page_type === this.dic.CONSTANTS.threatSimulationLandingPageType.quiz) {
					campaignTestObj.emailData.material_id = _.find(this.materials, {name: templateObj.ts_type})._id;
				}
				this.rs.testCampaignTemplate(campaignTestObj).then(response => {
					this.ns.showInfoMessage(`Template sent to ${this.userInfo.email}`);
				});
			}
		});
	}

	getTsTypeValue = (tsType) => {
		const typeObj = _.find(_.values(this.dic.CONSTANTS.threatSimulationType), {display: tsType});
		return typeObj?.value || tsType;
	}


	newCampaignExecute = (data) => {
		const recipients = _.uniqBy(_.flatMapDeep(data.selectedRecipients, recipientOrGroup => {
			if (recipientOrGroup.members?.length) {
				return _.map(recipientOrGroup.members, groupMember => {
					return {email: groupMember.email, name: groupMember.name}
				});
			}
			else {
				return {email: recipientOrGroup.email, name: recipientOrGroup.name};
			}
		}), 'email');


		let tsType;
		let landingPage = data.selectedTemplate?.landing_page_type;
		if (this.isTrainingCampaign) {
			if (data.selectedTemplate?.type === 'quiz') {
				tsType = this.dic.CONSTANTS.threatSimulationType.quiz.value;
				landingPage = this.dic.CONSTANTS.threatSimulationLandingPageType.quiz;
			}
			else {
				tsType = data.selectedTemplate?.ts_type || this.dic.CONSTANTS.threatSimulationType.materials.value;
				landingPage = data.selectedTemplate?.ts_type || this.dic.CONSTANTS.threatSimulationType.materials.value;
			}
		}
		else if (landingPage === this.dic.CONSTANTS.threatSimulationLandingPageType.materials ||
			landingPage === this.dic.CONSTANTS.threatSimulationLandingPageType.quiz) {
			tsType = this.dic.CONSTANTS.threatSimulationType.training.value;
		}
		else {
			tsType = this.getTsTypeValue(data.selectedTemplate?.ts_type);
		}

		if (!landingPage) {
			landingPage = data.selectedTemplate?.ts_type?.value || data.selectedTemplate?.ts_type ||
				this.dic.CONSTANTS.threatSimulationLandingPageType.training;
		}

		const campaignInfo: any = {
			name: data.name,
			description: data.description,
			emailData: {
				name: data.selectedTemplate?.name,
				ts_type: tsType,
				landing_page_type: landingPage
			},
			rcptTo: recipients,
			group_name: data.addToGroup.groupName || data.addToGroup.newGroupName || '',
			configuration: {
				expired_days: data.configuration.expired_days,
				send_report_when_completed: data.configuration.send_report_when_completed,
				send_training_when_completed: data.configuration.send_training_when_completed,
				pilot_campaign: data.configuration.pilot_campaign,
				notify_on_link_clicked: data.configuration.notify_on_link_clicked,
				apply_default_banners: data.configuration.apply_default_banners,
				notify_on_attachment_clicked: data.configuration.notify_on_attachment_clicked,
				enable_security_awareness_for_mailbox: data.configuration.enable_security_awareness_for_mailbox,
				security_awareness_for_mailbox_expire_days: data.configuration.security_awareness_for_mailbox_expire_days,
				enable_ack_reminder: data.configuration.enable_ack_reminder,
				enable_ack_reminder_hours: data.configuration.enable_ack_reminder_hours,
				scheduled_time_enabled: data.configuration.scheduled_time_enabled,
				scheduled_time: new Date(data.configuration.scheduled_time).toISOString(),
				rate_email_delivery_hours_duration: data.configuration.enable_rate_email_delivery_hours_duration && data.configuration.rate_email_delivery_hours_duration,
			}
		};

		if (data.repeatInterval.method === 'repeat') {
			campaignInfo.campaign_interval = {
				days: data.repeatInterval.interval,
				expiration: new Date(data.repeatInterval.until).toISOString()
			};
			campaignInfo.group_name = campaignInfo.group_name || campaignInfo.name;
		}

		if (this.isTrainingCampaign) {
			campaignInfo.emailData.material_id = data.selectedTemplate?._id;
			campaignInfo.fromName = data.fromName;
			campaignInfo.title = data.title;
			if (data.linkedQuiz?._id) {
				campaignInfo.emailData.linked_quiz_id = data.linkedQuiz._id;
			}
		}
		else if (landingPage === this.dic.CONSTANTS.threatSimulationLandingPageType.materials ||
			landingPage === this.dic.CONSTANTS.threatSimulationLandingPageType.quiz) {
			campaignInfo.emailData.material_id = _.find(this.materials, {name: data.selectedTemplate?.ts_type})?._id;
		}

		if (this.isMultipleTemplates) {
			const selectedTemplates = _.filter(this.templates, 'selected');
			if (selectedTemplates.length > 1) {
				campaignInfo.group_name = campaignInfo.group_name || this.data.name || '';
				campaignInfo.emailData = null;
				campaignInfo.multiTemplates = [];
				selectedTemplates.forEach((templateObj) => {
					const emailData:any = {
						name: templateObj.name,
						ts_type: templateObj.ts_type,
						landing_page_type: templateObj.landing_page_type
					};

					if (templateObj.landing_page_type === this.dic.CONSTANTS.threatSimulationLandingPageType.materials ||
						templateObj.landing_page_type === this.dic.CONSTANTS.threatSimulationLandingPageType.quiz) {
						emailData.material_id = _.find(this.materials, {name: templateObj.ts_type})._id;
					}

					campaignInfo.multiTemplates.push(emailData);
				});
			}
		}

		this.createNewCampaignInProcess = true;

		this.rs.createThreatSimulationCampaign(campaignInfo).then((response) => {
			this.ns.showInfoMessage(util.format(DICTIONARY.MESSAGES.itemCreated, 'Campaign "<b>' + campaignInfo.name + '</b>"'));
			this.launchedSuccessfully = true;
			this.createdCampaignId = response._id;
			this.createNewCampaignInProcess = false;
		}, (err) => {
			this.createNewCampaignInProcess = false;
		});
	}

	selectLandingPage = (landingPage) => {
		const templateObj = this.data.selectedTemplate;
		templateObj.ts_type = landingPage.display;

		let targetLink;
		switch (landingPage.display) {
			case this.dic.CONSTANTS.threatSimulationType.training.display:
				targetLink = `https://gss.trustifi.com/threatSimulation/landing.html?template=${templateObj.id || templateObj._id}`;
				templateObj.landing_page_type = this.dic.CONSTANTS.threatSimulationLandingPageType.training;
				break;

			case this.dic.CONSTANTS.threatSimulationType.login.display:
				targetLink = `https://gss.trustifi.com/threatSimulation/login.html?template=${templateObj.id || templateObj._id}`;
				templateObj.landing_page_type = this.dic.CONSTANTS.threatSimulationLandingPageType.login;
				break;

			default:
				targetLink = `https://gss.trustifi.com/threatSimulation/material.html?id=${landingPage._id}`;
				if (landingPage.type === 'quiz') {
					templateObj.landing_page_type = this.dic.CONSTANTS.threatSimulationLandingPageType.quiz;
				}
				else {
					templateObj.landing_page_type = this.dic.CONSTANTS.threatSimulationLandingPageType.materials;
				}
				break;
		}

		// find the landing page link - for system templates it's [0], for custom templates find by URL pattern
		const landingPageLinkObj = templateObj.lookup_links.find(link => link.link?.startsWith('https://gss.trustifi.com/threatSimulation/'))
									|| templateObj.lookup_links[0];

		// replace the link in the template html
		const currentLinkReg = new RegExp(_.escapeRegExp(landingPageLinkObj.link), 'g');
		templateObj.html = templateObj.html.replace(currentLinkReg, targetLink);
		landingPageLinkObj.link = targetLink;

		this.previewTemplate(templateObj);
	};

	previewTemplate = (templateObj, isVirtualOnly = false) => {
		if (!templateObj) {
			return;
		}

		// preview material
		if (this.isTrainingCampaign) {
			this.previewTemplateData = {
				name: templateObj.name
			};

			switch (templateObj.type) {
				case 'quiz':
					break;

				case 'Trustifi AI':
				case 'Hook Security':
				case 'AI':
				case 'link':
					this.previewLinkMaterial = this.sanitizer.bypassSecurityTrustResourceUrl(templateObj.link_url);
					break;

				case 'application/pdf':
				case 'video/mp4':
					this.getMaterialContent(this.data.selectedTemplate);
					break;

				default: // ppt
					this.getMaterialContentEnc(this.data.selectedTemplate);
			}
		}
		// preview template
		else {
			this.previewTemplateData.name = templateObj.name;

			this.previewTemplateData.virtualContent = this.composeMessageService.getSummernoteContent(templateObj);
			if (!isVirtualOnly) {
				this.previewTemplateData.content = this.composeMessageService.getSummernoteContent(templateObj);
			}
		}
	};

	getMaterialContentEnc = (material) => {
		this.previewTemplateInProcess = true;
		this.rs.getThreatSimulationMaterialContentEnc(material._id).then((enc) => {
			// first check if another item has been chosen while downloading the content
			if (this.previewTemplateData.name === material.name) {
				const pptUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${ENV_CONSTS.outsideUrl}/ts/content/${enc}?materialId=${material._id}`;
				this.previewTemplateData = {
					name: material.name,
					type: material.type,
					pptUrl: this.sanitizer.bypassSecurityTrustResourceUrl(pptUrl)
				};
			}

			this.previewTemplateInProcess = false;
		}, err => {
			console.error(err);
			this.ns.showErrorMessage(this.dic.ERRORS.fileDownloadFailed);
			this.previewTemplateInProcess = false;
		});
	}

	getMaterialContent = (material) => {
		this.previewTemplateInProcess = true;

		this.http.get(ENV_CONSTS.attachmentUrl + '/admin/threatSimulation/material/content/' + material._id,{
			responseType: 'arraybuffer',
			headers: this.gs.getHeaders(),
			observe: 'response'
		}).subscribe((response) => {
			if (response && response.body.byteLength === 0) {
				this.ns.showErrorMessage(this.dic.ERRORS.fileDownloadFailed);
			}

			// first check if another item has been chosen while downloading the content
			if (this.previewTemplateData.name === material.name) {
				this.previewTemplateData.content = {
					name: material.name,
					type: material.type,
					content: response
				};
			}

			this.previewTemplateInProcess = false;
		}, err => {
			console.error(err);
			this.ns.showErrorMessage(this.dic.ERRORS.fileDownloadFailed);
			this.previewTemplateInProcess = false;
		});
	}

	captureTemplateScreenshot = (iframeDoc) => {
		if (!this.previewTemplateData.name) {
			return;
		}

		html2canvas(iframeDoc.body).then(canvas => {
			canvas.style.height = '100%';
			canvas.style.width = '100%';

			this.templatesScreenshots[this.previewTemplateData.name] = canvas;
		}, err => {
			console.error(err);
		});
	}

	toggleExpandItem = (item, event) => {
		if (!item.members?.length) {
			return;
		}

		item.isExpanded = !item.isExpanded;
		event.stopPropagation();

		this.recipientsTableEl.searchItem();
	}

	searchCampaignRecipients = (searchTerm, activeFilters) => {
		this.allPossibleRecipients.forEach(record => {
			if ((record.members?.length && !this.showGroups) || (!record.members?.length && !this.showMailboxes)) {
				record.isExpanded = false;
				record.hide = true;
				return;
			}

			// search
			let isFound = this.searchRecipientTextExecute(record, searchTerm);
			if (!isFound) {
				record.hide = true;
				return;
			}

			// CC: filter
			if (activeFilters && !this.searchFilterExecute(record, activeFilters)) {
				record.isExpanded = false;
				record.hide = true;
				return;
			}

			record.hide = false;
		});
	};

	// CC: a group is displayed when its own name/email matches the search, or when any of its members matches.
	// members that do not match are hidden within the group
	searchRecipientTextExecute = (recipientOrGroup, searchTerm) => {
		if (!recipientOrGroup.members?.length) {
			return searchTextExecute(recipientOrGroup, searchTerm);
		}

		// the group itself matches, so all of its members are displayed
		if (searchTextExecute(recipientOrGroup, searchTerm)) {
			showAllGroupMembers(recipientOrGroup);
			return true;
		}

		let isMemberFound = false;
		recipientOrGroup.members.forEach(member => {
			member.hide = !this.searchRecipientTextExecute(member, searchTerm);
			if (!member.hide) {
				isMemberFound = true;
			}
		});

		return isMemberFound;
	};

	// CC: taken from inbound-mailboxes.component.ts -> searchFilterExecute
	searchFilterExecute = (recipientOrGroup, filters) => {
		// CC: a group has no license of its own, so it is displayed when any of its members matches the filters.
		// members that do not match are hidden within the group
		if (recipientOrGroup.members?.length) {
			let isMemberFound = false;
			recipientOrGroup.members.forEach(member => {
				// members that were already hidden by the search stay hidden
				member.hide = member.hide || !this.searchFilterExecute(member, filters);
				if (!member.hide) {
					isMemberFound = true;
				}
			});

			return isMemberFound;
		}

		// need to match all filter types
		let numFilterToMatch = Object.keys(filters).length;

		if (filters.license?.length && filters.license.includes(recipientOrGroup.license)) {
			numFilterToMatch--;
		}

		return !numFilterToMatch;
	};

	deselectRecipient = (contactObj) => {
		contactObj.selected = false;

		// trigger the trustifi-table search by changing the list. The directive detects changes and fires a search
		// needed to update the "select all" checkbox state
		this.allPossibleRecipients = _.cloneDeep(this.allPossibleRecipients);
	}

	updateDynamicFields = () => {
		this.showDynamicFieldsPopup = false;

		this.loadCampaignDataInProcess = true;

		this.getTemplates().then(results => {
			this.loadCampaignDataInProcess = false;
			this.data.selectedTemplate = this.templates.find(itm => itm.name === this.data.selectedTemplate?.name);
			this.previewTemplate(this.data.selectedTemplate);
		})
		.catch(error => {
			this.loadCampaignDataInProcess = false;
		});
	}

	downloadAttachment = (data, name, type) => {
		try {
			// data = new Buffer(data, 'base64');
			this.gs.downloadData(data, name, type);
		} catch (err) {
			console.error(err);
		}
	};

	intervalValidation = () => {
		if (this.data.repeatInterval.interval < 1) {
			this.ns.showErrorMessage('Days input should be at least 1');
			this.data.repeatInterval.intervalError = true;
			return true;
		}

		const targetDate = new Date(this.now);
		targetDate.setDate(targetDate.getDate() + this.data.repeatInterval.interval);

		const untilDate = new Date(this.data.repeatInterval.until);

		if (targetDate > untilDate) {
			this.ns.showErrorMessage('Cannot set interval to more than the "Until" date');
			this.data.repeatInterval.intervalError = true;
			return true;
		}

		return false;
	}
}


// CC: taken from inbound-mailboxes.component.ts -> showAllSubMailboxes
// when a group is found by the search, remove the hide flag from its members (also resets members hidden by a previous search)
function showAllGroupMembers(group) {
	if (group.members?.length) {
		group.members.forEach(member => {
			member.hide = false;
			showAllGroupMembers(member);
		});
	}
}

function searchTextExecute(record, searchTerm) {
	return ((record.name?.toLowerCase().indexOf(searchTerm) > -1) ||
		(record.email?.toLowerCase().indexOf(searchTerm) > -1))
}
